import request from '@/shared/api/request';

/**
 *
 * Makes the current user verified.
 *
 * @returns {Promise}
 */
export const confirm = (token: string): Promise<void> =>
  request({
    url: `/account/register/verification_email/${token}/`,
    method: 'GET',
  });
